function TickIcon({ color = "#8D8D93", className, style }) {
  return (
    <svg
      width={20}
      height={14}
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M2 7.37l3.882 3.881a1 1 0 001.34.067L18 2.5"
        stroke={color}
        strokeWidth={4}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default TickIcon;
